import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-ui-button-toggle',
  styleUrls: ['./ui-button-toggle.component.scss'],
  templateUrl: './ui-button-toggle.component.html',
  standalone: false
})
export class UIButtonToggleComponent {
  @Input() checked: boolean;
  @Output() changeEventDispatch = new EventEmitter<boolean>();
  @ViewChild('changeEvent', { static: false }) checkBox: ElementRef;

  onChangeEvent(value: boolean): void {
    (this.checkBox.nativeElement as HTMLInputElement).blur();
    this.changeEventDispatch.emit(value);
  }
}
